import React from 'react';
import { motion } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/wHyD52gxNFqji4KqccZ1ZG/hoja_1.webp', 'https://cdn.magicpatterns.com/uploads/b4Ck7xCg7J4PF3QkxbHBq4/hoja_2.webp', 'https://cdn.magicpatterns.com/uploads/3P6xixYbEcX2PTVBr3j3zh/hoja_3.webp', 'https://cdn.magicpatterns.com/uploads/wDrwR65Kp7kFPvnTBHYVjH/hoja_4.webp', 'https://cdn.magicpatterns.com/uploads/676QXQQhRR8Mj8gugMNdBL/hoja_5.webp'];
export function ImageCarousel() {
  // Duplicate the images array to create a seamless loop
  const duplicatedImages = [...images, ...images];
  return <section className="py-12 bg-[#2C2541] overflow-hidden" data-id="element-139">
      <div className="relative flex" data-id="element-140">
        <motion.div className="flex gap-4 px-4" animate={{
        x: [0, -1250] // Adjust based on image width + gap
      }} transition={{
        duration: 40,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-141">
          {duplicatedImages.map((src, index) => <div key={index} className="shrink-0 w-[250px] md:w-[350px] overflow-hidden rounded-xl border border-[#D9B15F]/10 shadow-lg" data-id="element-142">
              <img src={src} alt={`Preview ${index + 1}`} className="w-full h-auto block" data-id="element-143" />
            </div>)}
        </motion.div>
      </div>
    </section>;
}